import React from 'react';
import { useTranslation } from 'react-i18next';
import { DiaryTopics } from '@/components/DiaryTopics';
import { HomeTaskAttachments } from '@/components/HomeTaskModal/HomeTaskAttachments';
import { AuthorInfo } from '@/components/LessonDetailsModal/AuthorInfo';
import { DETAILS_CARD } from '@/components/LessonDetailsModal/classNames';
import type { Attachment } from '@/types/attachment';
import { AttachmentsDisplay } from '@/types/components';
import type { DiaryTopic } from '@/types/diary';
import { sortByDateDesc } from '@/utils/date';

interface Props {
  topics: DiaryTopic[];
  onPreview: (attachment: Attachment) => void;
}

export const LessonTopicsCard: React.FC<Props> = ({ topics, onPreview }) => {
  const { t } = useTranslation();

  const attachments = topics.flatMap((topic) => topic.attachments);
  const [latestTopic] = sortByDateDesc(
    topics,
    ({ timeCreated }) => timeCreated,
  );

  return (
    <div className={`flex flex-col gap-3 ${DETAILS_CARD}`}>
      {topics.length > 0 && (
        <DiaryTopics
          topics={topics}
          isFullText
          attachmentsDisplay={AttachmentsDisplay.Hidden}
          className="text-body-14 text-foreground"
        />
      )}
      {topics.length === 0 && (
        <p className="text-body-14 text-foreground">
          {t('diary.emptyDescription')}
        </p>
      )}

      <HomeTaskAttachments
        isFullWidth
        attachments={attachments}
        onPreview={onPreview}
      />

      {latestTopic && (
        <AuthorInfo
          authorName={latestTopic.authorName}
          timeCreated={latestTopic.timeCreated}
          lastModification={latestTopic.lastModification}
        />
      )}
    </div>
  );
};
